
import moment from 'moment';

export class DateFormatValueConverter {
    toView(value) {
        if (!value)
            return null;

        var d = new Date(Date.parse(value.replace(/-/g, '/') + " UTC"));
        return moment(d).format('M/D/YYYY h:mm:ss A');
    }
}

